var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmplifyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "576px",
    height: "580px",
    viewBox: "0 0 576 580",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Template---App-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Amplify-Icon",
    transform: "translate(-224, -222)",
    fill: "color(display-p3 1.000 1.000 1.000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(224, 221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,1 C211.1729,1 138.817219,30.8522801 84.3472124,85.2406809 C29.8772054,139.629082 0,212.010638 0,288.890482 C0,349.617381 18.6986591,407.481732 53.2505293,455.94057 L90.241355,400.325364 C71.7459421,367.406068 60.9738885,329.375081 60.9738885,288.890482 C60.9738885,163.756267 162.800282,61.9313663 288,61.9313663 C413.199718,61.9313663 515.026112,163.756267 515.026112,288.890482 C515.026112,329.375081 504.254058,367.610536 485.555399,400.529831 L522.546224,456.145038 C557.301341,407.6862 576,349.821849 576,289.09495 C576,212.215105 546.122795,139.833549 491.652788,85.4451486 C437.386027,30.8522801 365.030346,1 288,1 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "409.479261 446.40458 372.550459 548.221816 382.087018 581 382.289923 581 382.289923 581 574.238532 581 501.801266 472.012537"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "74.1987337 472.012537 1.76146789 581 193.912982 581 203.449541 548.221816 166.317834 446.40458"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "454.458716 401.122966 288 152.419847 121.541284 401.122966 202.427588 376.579895 231.155469 461.458015 288 277.589509 344.844531 461.458015 373.776156 376.579895"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplifyLogo);
export default __webpack_public_path__ + "static/media/amplify-logo.4e727aff5fc625599aa6e85ce06675d9.svg";
export { ForwardRef as ReactComponent };